import config from '../config';

const apiRequest = async (URN, method = 'GET', data) => {
    const options = {
        method,
        headers: {
            Accept: 'application/json',
            'x-access-token': config.tokensecret,
        },
        credentials: 'include',
    };

    if (method !== 'GET') {
        options.body = JSON.stringify(data);
        options.headers['Content-Type'] = 'application/json';
    }

    let res;
    try {
        res = await fetch(config.serverUrl.concat(URN), options).then((res) => res.text());
    } catch (error) {
        throw error;
    }

    try {
        const json = JSON.parse(res);

        if (json.status < 200 || json.status >= 300) {
            const error = new Error(json.message);
            error.type = 'ApiError';
            throw error;
        }

        return json;
    } catch (e) {
        if (e.type === 'ApiError') {
            throw e;
        }
    }

    return res;
};

export default apiRequest;
